export default __webpack_public_path__ + "static/media/ic_danger.b983199f.svg";